<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            RSS Journal Feed - COVID-19 Data Dashboard:
          </h4>
          <Breadcrumbs
            :breadcrumbs="[
              { title: 'Dashboards', to: `/dashboard` },
              { title: 'Victorian Dashboard', to: '/dashboards/victoria' }
            ]"
          />

          <p class="mt-2">
            Articles are sourced from the official RSS feed released from the
            respective journal.
          </p>
          <p>
            To keep the content relevant to you, these articles have been
            filtered for reference to COVID-19, SARS-CoV-2, and Coronavirus.
          </p>
        </vx-card>
      </div>
    </div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vs-card>
          <vs-row vs-justify="center">
            <div class="pt-4">
              <vs-col
                vs-type="flex"
                vs-align="center"
                vs-justify="center"
                style="flex-direction: column; box-shadow: none; background: none;"
                :class="journal"
              >
                <h3 v-html="generateJournalTitle"></h3>
                <a class="mb-4" :href="generateJournalHref" target="_blank"
                  >Select a card to read more</a
                >
              </vs-col>
            </div>
          </vs-row>
          <div
            class="p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-6 gap-4"
          >
            <vs-card
              v-for="(month, indexMonth) in months"
              :key="indexMonth"
              :class="journal"
              style="box-shadow: none; background: #fff;"
            >
              <vs-row vs-justify="center">
                <div class="p-2">
                  <vs-col vs-type="flex" vs-align="center">
                    <h4>{{ months[indexMonth.toString()] }}</h4>
                  </vs-col>
                </div>
              </vs-row>
              <RssFeedCard
                v-for="(article, index) in filteredJournalResults"
                v-if="calculateMonth(article.date) === month"
                :key="index"
                :article="article"
              ></RssFeedCard>
            </vs-card>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import RssFeedCard from "@/modules/dashboard/components/RssFeedCard";
import moment from "moment";

export default {
  name: "RssJournalFeed",
  components: {
    Breadcrumbs,
    RssFeedCard
  },
  props: {
    journal: {
      type: String,
      default: ""
    }
  },
  computed: {
    filteredJournalResults() {
      return this.$store.getters.rssJournalResults(this.journal);
    },
    generateJournalTitle() {
      let titles = {
        lancet: "The Lancet",
        ersj: "European Respiratory Society Journal",
        jama: "JAMA <span>network</span>",
        nejm: "<span>The</span> New England Journal <span>of</span> Medicine"
      };

      return titles[this.journal];
    },
    generateJournalHref() {
      let hrefs = {
        lancet: "https://www.thelancet.com/coronavirus",
        ersj:
          "https://www.ersnet.org/the-society/news/novel-coronavirus-outbreak--update-and-information-for-healthcare-professionals",
        jama: "https://jamanetwork.com/collections/46099/coronavirus-covid19",
        nejm: "https://www.nejm.org/coronavirus"
      };

      return hrefs[this.journal];
    }
  },
  data() {
    return {
      months: {
        "0": moment().format("MMMM"),
        "1": moment()
          .subtract(1, "months")
          .format("MMMM"),
        "2": moment()
          .subtract(2, "months")
          .format("MMMM"),
        "3": moment()
          .subtract(3, "months")
          .format("MMMM"),
        "4": moment()
          .subtract(4, "months")
          .format("MMMM"),
        "5": moment()
          .subtract(5, "months")
          .format("MMMM")
      }
    };
  },
  methods: {
    calculateMonth(date) {
      return moment(date, "DD-MM-YYYY").format("MMMM");
    }
  }
};
</script>

<style lang="scss" scoped>
.jama ::v-deep .con-vs-card,
.nejm ::v-deep .con-vs-card,
.lancet ::v-deep .con-vs-card,
.ersj ::v-deep .con-vs-card {
  border: rgba(26, 26, 26, 0.4) 1px solid !important;
  box-shadow: none;
}

.jama ::v-deep .con-vs-card.withHover:hover,
.nejm ::v-deep .con-vs-card.withHover:hover,
.lancet ::v-deep .con-vs-card.withHover:hover,
.ersj ::v-deep .con-vs-card.withHover:hover {
  transform: none !important;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;
}
</style>

<!---->

<!-- podcasts https://sites.jamanetwork.com/audio/-->
<!--latest articles https://jamanetwork.com/journals/jama-->
<!--rss feeds https://jamanetwork.com/pages/rss-->
<!--coronavirus https://jamanetwork.com/journals/jama/pages/coronavirus-alert-->
<!--https://jamanetwork.com/journals/jama/pages/covid-19-interviews-->
<!--machine learning https://sites.jamanetwork.com/machine-learning/-->
<!-- audio and podcast courses free learning content https://edhub.ama-assn.org/jn-learning/by-topic?hd=edhub&f_SiteDisplayNames=JN+Learning&f_ContentFormat=Audio&page=1-->

<!--<div>-->
<!--  <p>-->
<!--    Clinical Reviews-->
<!--    https://jamanetwork.com/journals/jama/pages/jama-clinical-reviews-->
<!--  </p>-->
<!--  <p>Coronavirus (COVID-19) Q&A https://covid19jama.libsyn.com/rss</p>-->
<!--  <p>-->
<!--    Latest from Jama network https://jamanetwork.com/rss/site_3/67.xml-->
<!--  </p>-->
<!--</div>-->

<!--<div class="p-4 grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 ">-->
<!--  <vs-card-->
<!--    :class="journal"-->
<!--    outline-->
<!--    v-for="(article, index) in rssArticles"-->
<!--    :key="index"-->
<!--    :article="article"-->
<!--  >-->
<!--    <div class="flex flex-row">-->
<!--      <p class="text-sm article-title">-->
<!--        {{ article.title }}-->
<!--      </p>-->
<!--    </div>-->
<!--    <div class=" mt-1 flex flex-row">-->
<!--      <p>-->
<!--        <span class=" mr-1 text-sm font-semibold">Published: </span>-->
<!--        {{ article.date }}-->
<!--      </p>-->
<!--    </div>-->
<!--  </vs-card>-->
<!--</div>-->
